interface Option {
	value: string;
	label: string;
	key?: string;
	disabled?: boolean;
}

export const checkboxValueBrand = (selected: Array<Option>) => {
	return selected.length ? `${selected.length} brand dipilih` : 'Pilih Brand';
};
